'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('./internal/_get');

var _get3 = _interopRequireDefault(_get2);

var _set2 = require('./internal/_set');

var _set3 = _interopRequireDefault(_set2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function update(key, updater, subject) {
  var value = (0, _get3.default)(key, subject);
  return (0, _set3.default)(key, updater(value), subject);
}

/**
 * Sets the value at `key` to the result of `updater`.
 *
 * @example
 * const incrementCount = update('count', n => n + 1);
 * incrementCount({count: 1});
 * // returns {count: 2}
 *
 * @param {any} key
 * @param {Function} updater
 * @param {Array|Iterable|Object} subject
 * @return {Array|Iterable|Object}
 */
exports.default = (0, _curry2.default)(update);
module.exports = exports['default'];